import React, { reactCSS, Component } from 'react';
import { SwatchesPicker, SketchPicker, ChromePicker } from 'react-color';
import Select from 'react-select';

const selectValues = [
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-topLeft"></span></i> Topo esquerda</div>, value: "topLeft" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-topCenter"></span></i> Topo centro</div>, value: "topCenter" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-topRight"></span></i> Topo direita</div>, value: "topRight" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-centerLeft"></span></i> Centro esquerda</div>, value: "centerLeft" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-centerCenter"></span></i> Centro</div>, value: "centerCenter" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-centerRight"></span></i> Centro direita</div>, value: "centerRight" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-bottomLeft"></span></i> Fundo esquerda</div>, value: "bottomLeft" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-bottomCenter"></span></i> Fundo centro</div>, value: "bottomCenter" },
  { label: <div><i className="linearicons-grid" style={{marginRight: "15px"}}><span className="paint paint-bottomRight"></span></i> Fundo direita</div>, value: "bottomRight" },
]

class AlertProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alertContent: "",
      alertContentColor: "#FFF",
      alertBackgroundColor: "#C04848",
      alertPosition: "topRight",

      alertContentDisplayColorPicker: false,
      alertBackgroundDisplayColorPicker: false
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
    this.handleAlertPositionChange = this.handleAlertPositionChange.bind(this);
  }

  handleClick = (e) => {
    if ( !e.target.getAttribute('data-picker') ) return

    let propName = e.target.getAttribute('data-picker')+'DisplayColorPicker'
    this.setState({ [propName]: !this.state[propName] })
  }

  handleAlertPositionChange(e) {
    this.setState({alertPosition: e.value}, () => {
      let obj = {
        alertContent: this.state.alertContent,
        alertContentColor: this.state.alertContentColor,
        alertBackgroundColor: this.state.alertBackgroundColor,
        alertPosition: this.state.alertPosition
      }

      this.props.handleWebviewProps(obj, true);
    });
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value}, () => {
      let obj = {
        alertContent: this.state.alertContent,
        alertContentColor: this.state.alertContentColor,
        alertBackgroundColor: this.state.alertBackgroundColor,
        alertPosition: this.state.alertPosition
      }

      this.props.handleWebviewProps(obj, true);
    });
  }

  handleColorChange = (color, elem) => {
    let propName = elem+'Color';
    this.setState({ [propName]: color.hex }, () => {
      let obj = {
        alertContent: this.state.alertContent,
        alertContentColor: this.state.alertContentColor,
        alertBackgroundColor: this.state.alertBackgroundColor,
        alertPosition: this.state.alertPosition
      }

      this.props.handleWebviewProps(obj, true);
    })
  }

  handleSubmit = (e) => {
    if ( !this.state.alertContent || this.state.alertContent.length === 0 ) return;

    let obj = {
      alertContent: this.state.alertContent,
      alertContentColor: this.state.alertContentColor,
      alertBackgroundColor: this.state.alertBackgroundColor,
      alertPosition: this.state.alertPosition
    }

    this.props.handleWebviewProps(obj, false);
  }

  render() {
    return(
      <div className="webview-component-group">
        <div className="webview-data-group">
          <p className="group-title">Conteúdo:</p>
          <div className="row">
            <div className="col-6">
              <div className="input-wrapper">
                <label htmlFor="alertContent">Qual será o conteúdo do seu alerta? <strong>(Obrigatório)</strong></label>
                <textarea name="alertContent" id="alertContent" className="form-control" onChange={this.handleChange} defaultValue={this.state.alertContent}></textarea>
              </div>
            </div>
            <div className="col-6">
              <div className="input-wrapper">
                <label htmlFor="alertContent">Em qual posição o alerta ficará?</label>
                 <Select
                  options={selectValues}
                  className="basic-select"
                  classNamePrefix="select"
                  placeholder="Posição do alerta (Padrão: Topo direita)"
                  onChange={this.handleAlertPositionChange}
                />
              </div>
            </div>
          </div>

          <div className="webview-data-group">
            <p className="group-title">Estilo:</p>
            <div className="row">
              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor do conteúdo?</label>
                  {
                    this.state.alertContentDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.alertContentColor } onChange={ (color) => { this.handleColorChange(color, 'alertContent') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="alertContent"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="alertContent" style={{width: "76px", height: "38px", backgroundColor: this.state.alertContentColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>

              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor de fundo do alerta?</label>
                  {
                    this.state.alertBackgroundDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.alertBackgroundColor } onChange={ (color) => { this.handleColorChange(color, 'alertBackground') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="alertBackground"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="alertBackground" style={{width: "76px", height: "38px", backgroundColor: this.state.alertBackgroundColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" className="btn btn-blue" style={{marginTop: "60px"}} onClick={this.handleSubmit}>Salvar</button>
      </div>
    )
  }
}

export { AlertProperties as Alert }